export function isZestyEmail(email: string): boolean {
  return email.endsWith("@zesty.io") || email.endsWith("@content.one");
}
